<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.sourceBankAccountId"
          v-bind="getObject('sourceBankAccountId')"
          label="Conta de Origem"
          :items="extraData.accountContext.allBankAccounts"
          item-value="id"
          item-text="nameWithBank"
          @input="selectSourceBankAccount"
          :hint="entry.sourceBankAccountId ? ('Saldo Atual: ' + numberToCurrency(entry.sourceBankAccount.currentBalance) + ', Tipo: ' + entry.sourceBankAccount.bankAccountType.name + (entry.sourceBankAccount.agencyNumber ? ' - Agência: ' + entry.sourceBankAccount.agencyNumber : '') + (entry.sourceBankAccount.agencyNumber ? ' - Número: ' + entry.sourceBankAccount.accountNumber : '')) : '' "
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.nameWithBank}}</v-list-item-title>
              <v-list-item-subtitle>
                Saldo Atual: <strong>{{numberToCurrency(data.item.currentBalance)}}</strong>, 
                Tipo: {{data.item.bankAccountType.name}}
                {{data.item.agencyNumber ? '- Agência: ' + data.item.agencyNumber : ''}}
                {{data.item.agencyNumber ? '- Número: ' + data.item.accountNumber : ''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:append-outer>
            <BankAccountNew
              :inlineAddButton="true"
              @entry-created="sourceBankAccountCreated"
              modelNameSingular="Conta Bancária de Origem"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.targetBankAccountId"
          v-bind="getObject('targetBankAccountId')"
          label="Conta de Destino"
          :items="extraData.accountContext.allBankAccounts"
          item-value="id"
          item-text="nameWithBank"
          @input="selectTargetBankAccount"
          :hint="entry.targetBankAccountId ? ('Saldo Atual: ' + numberToCurrency(entry.targetBankAccount.currentBalance) + ', Tipo: ' + entry.targetBankAccount.bankAccountType.name + (entry.targetBankAccount.agencyNumber ? ' - Agência: ' + entry.targetBankAccount.agencyNumber : '') + (entry.targetBankAccount.agencyNumber ? ' - Número: ' + entry.targetBankAccount.accountNumber : '')) : '' "
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.nameWithBank}}</v-list-item-title>
              <v-list-item-subtitle>
                Saldo Atual: <strong>{{numberToCurrency(data.item.currentBalance)}}</strong>, 
                Tipo: {{data.item.bankAccountType.name}}
                {{data.item.agencyNumber ? '- Agência: ' + data.item.agencyNumber : ''}}
                {{data.item.agencyNumber ? '- Número: ' + data.item.accountNumber : ''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:append-outer>
            <BankAccountNew
              :inlineAddButton="true"
              @entry-created="targetBankAccountCreated"
              modelNameSingular="Conta Bancária de Destino"
            />
          </template>
        </v-autocomplete>

      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('value')"
          :inputData.sync="entry.value"
          mask-type="currency"
          label="Valor"
          prefix="R$"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <!-- <DateField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data"
          :hasTodayDate="true"
        /> -->
        <DateTimeField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data e Hora"
          :hasTodayDate="true"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import DateTimeField from "@shared_components/date_time_field.vue"
import BankAccountNew from "@models/bank_accounts/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    DateTimeField: DateTimeField,
    BankAccountNew: BankAccountNew,
    BaseUtil: BaseUtil
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectSourceBankAccount: function() {
      this.entry.sourceBankAccount = this.extraData.accountContext.allBankAccounts.find(obj => obj.id == this.entry.sourceBankAccountId);
    },
    selectTargetBankAccount: function() {
      this.entry.targetBankAccount = this.extraData.accountContext.allBankAccounts.find(obj => obj.id == this.entry.targetBankAccountId);
    },
    sourceBankAccountCreated: function(bankAccount) {
      // if (bankAccount.bankAccountType.isCashKeeper) {
      //   this.$refs.util.showErrorMessage("A conta bancária de origem criada é do tipo Caixa, por isso não irá aparecer na lista de contas bancárias de origem!");
      // } else {
      this.extraData.accountContext.allBankAccounts.unshift(bankAccount);
      this.entry.sourceBankAccountId = bankAccount.id;
      this.entry.sourceBankAccount = bankAccount;
      // }
    },
    targetBankAccountCreated: function(bankAccount) {
      // if (bankAccount.bankAccountType.isCashKeeper) {
      this.extraData.accountContext.allBankAccounts.unshift(bankAccount);
      this.entry.targetBankAccountId = bankAccount.id;
      this.entry.targetBankAccount = bankAccount;
      // } else {
        // this.$refs.util.showErrorMessage("A conta bancária de destino criada não é do tipo Caixa, por isso não irá aparecer na lista de contas bancárias de destino!");
      // }
    },
  }
};
</script>

<style scoped></style>
